"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CultureContext = void 0;
const react_1 = require("react");
exports.CultureContext = (0, react_1.createContext)({ locale: 'fr-fr', siteId: 1 });
const useCulture = () => {
    const culture = (0, react_1.useContext)(exports.CultureContext);
    const isPrivalia = (culture === null || culture === void 0 ? void 0 : culture.siteId) === 66 || (culture === null || culture === void 0 ? void 0 : culture.siteId) === 69;
    const isBenelux = (culture === null || culture === void 0 ? void 0 : culture.siteId) === 70 || (culture === null || culture === void 0 ? void 0 : culture.siteId) === 71 || (culture === null || culture === void 0 ? void 0 : culture.siteId) === 73 || (culture === null || culture === void 0 ? void 0 : culture.siteId) === 76;
    return { culture, isBenelux, isPrivalia };
};
exports.default = useCulture;
